var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectModeSelect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 57,
    viewBox: "0 0 75 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Image"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 63",
    width: 34,
    height: 32,
    rx: 4,
    fill: "#E3EDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 64",
    x: 40,
    width: 34,
    height: 32,
    rx: 4,
    fill: "#E3EDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 65",
    x: 0.5,
    y: 42.5,
    width: 33,
    height: 14,
    rx: 7,
    stroke: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 9",
    opacity: 0.5,
    x1: 7.5,
    y1: 49.5,
    x2: 19.5,
    y2: 49.5,
    stroke: "#373737",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 66",
    x: 41.5,
    y: 42.5,
    width: 33,
    height: 14,
    rx: 7,
    stroke: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Image_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 68",
    x: 6,
    y: 5,
    width: 21,
    height: 21,
    rx: 2,
    fill: "#E3EDFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 11,
    cy: 10,
    r: 2,
    fill: "#202125"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6907 17.4378C11.9294 17.0933 12.5061 17.0933 12.7448 17.4378L15.347 21.1938C15.5928 21.5486 15.2977 22 14.8199 22H9.61557C9.13783 22 8.84274 21.5486 9.08854 21.1939L11.6907 17.4378Z",
    fill: "#202125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4616 15.2444C18.7035 14.9185 19.2536 14.9185 19.4956 15.2444L23.9014 21.1799C24.1643 21.5341 23.8706 22 23.3844 22H14.5728C14.0865 22 13.7928 21.5341 14.0558 21.1799L18.4616 15.2444Z",
    fill: "#202125"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Image_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 68_2",
    x: 46,
    y: 5,
    width: 21,
    height: 21,
    rx: 2,
    fill: "#E3EDFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1_2",
    cx: 51,
    cy: 10,
    r: 2,
    fill: "#202125"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6907 17.4378C51.9294 17.0933 52.5061 17.0933 52.7448 17.4378L55.347 21.1938C55.5928 21.5486 55.2977 22 54.8199 22H49.6156C49.1378 22 48.8427 21.5486 49.0885 21.1939L51.6907 17.4378Z",
    fill: "#202125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4616 15.2444C58.7035 14.9185 59.2536 14.9185 59.4956 15.2444L63.9014 21.1799C64.1643 21.5341 63.8706 22 63.3844 22H54.5728C54.0865 22 53.7928 21.5341 54.0558 21.1799L58.4616 15.2444Z",
    fill: "#202125"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 69",
    y: 10,
    width: 34,
    height: 28.102,
    rx: 4,
    fill: "#D0D1D6"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 10",
    opacity: 0.5,
    x1: 5.5,
    y1: 16.7861,
    x2: 27.5,
    y2: 16.7861,
    stroke: "#373737",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 11",
    opacity: 0.5,
    x1: 5.5,
    y1: 24.0713,
    x2: 27.5,
    y2: 24.0713,
    stroke: "#373737",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 12",
    opacity: 0.5,
    x1: 5.5,
    y1: 31.3574,
    x2: 27.5,
    y2: 31.3574,
    stroke: "#373737",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectModeSelect);
export default __webpack_public_path__ + "static/media/select-mode-select.e4863061766b92b83695fccf40ea58f5.svg";
export { ForwardRef as ReactComponent };